module.exports = __webpack_public_path__ + "static/img/2.5739811.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/ddjy/2.png
// module id = Kxgp
// module chunks = 0